import { toast } from 'react-toastify';

// フェッチAPIのエラー処理を行う
function handleFetchFailures(error) {
  let errorMessage = 'エラーが発生しました。';
  const response = error.cause;
  if (response) {
    if (500 <= response.status) {
      switch (response.status) {
      case 503:
      case 504:
        errorMessage = '一時的なエラーが発生しました。数分後に再度お試しください。';
        break;
      default:
        errorMessage = 'エラーが発生しました。しばらく時間をおいて再度お試しください。';
      }
    }
  }
  toast.warn(errorMessage);
}

// サーバーエラーの場合は例外を発生させる
function raiseIfServerError(response) {
  if (500 <= response.status) {
    throw new Error('サーバーエラー', { cause: response });
  }
}

export {
  handleFetchFailures,
  raiseIfServerError,
};
